var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { t } from "../../I18N";

import { showFilters, hideFilters } from "../actions/libraryActions";
import { wrapDispatch } from "../../Multireducer";
import { Icon } from "../../UI";
import { unselectAllDocuments } from "../actions/libraryActions";

export class SearchButton extends Component {
  render() {
    let toggle = this.props.open ? this.props.hideFilters : this.props.showFilters;
    let activeClass = this.props.open ? ' is-active' : '';

    if (this.props.open && this.props.metadataPanelIsOpen) {
      toggle = this.props.unselectAllDocuments;
      activeClass = '';
    }

    if (!this.props.open && this.props.metadataPanelIsOpen) {
      toggle = () => {
        this.props.showFilters();
        this.props.unselectAllDocuments();
      };
    }

    return /*#__PURE__*/(
      _jsx("a", { href: "#", className: `search-button btn ${activeClass}`, onClick: toggle }, void 0, /*#__PURE__*/
      _jsx("div", { className: "searchButton-open" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "funnel-filter" }), /*#__PURE__*/
      _jsx("span", {}, void 0, t('System', 'Search'), "..."))));



  }
}









SearchButton.contextTypes = {
  storeKey: PropTypes.string
};

export function mapStateToProps(state, props) {
  return {
    open: state[props.storeKey].ui.get('filtersPanel') !== false,
    metadataPanelIsOpen: state[props.storeKey].ui.get('selectedDocuments').size > 0
  };
}

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
  {
    showFilters,
    hideFilters,
    unselectAllDocuments
  },
  wrapDispatch(dispatch, props.storeKey));

}

export default connect(mapStateToProps, mapDispatchToProps)(SearchButton);